import React from 'react'
import { Button, Grid } from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import { cubicajeSchema } from '../../constants'

export const OperacionNuevoCubicajeView = ({ silo: { altura, nombreCorto }, aceptar, cancelar }) => (
  <Formik initialValues={{ metrosDeVacio: '', ph: '' }} onSubmit={aceptar} validationSchema={cubicajeSchema(altura)}>
    {({ isSubmitting, isValid }) => (
      <Form>
        <Grid container spacing={2}>
          <Grid container item spacing={2}>
            <Grid item xs={12}>
              <h2>Cubicaje de {nombreCorto}</h2>
            </Grid>
          </Grid>
          <Grid container item spacing={2}>
            <Grid item xs={12} sm={6}>
              <Field component={TextField} name='metrosDeVacio' type='text' label='Metros de vacio' />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field component={TextField} name='ph' type='number' label='ph' />
            </Grid>
          </Grid>
          <Grid container item spacing={2} justify='space-between'>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='secondary'
                disabled={isSubmitting}
                startIcon={<HighlightOffIcon />}
                onClick={cancelar}>
                Cancelar
              </Button>
            </Grid>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='primary'
                disabled={isSubmitting || !isValid}
                startIcon={<CheckCircleOutlineIcon />}
                type='submit'>
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
)
